import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import type { DisplayTemplateAst, FieldSelection, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { computed, toValue } from 'vue';
import { idFieldSelectionToFieldSelection, resolveCollectionDisplayTemplateFields } from '#layers/data-model/public';
import { useFieldSelectionContexts } from './use-field-selection-contexts';

export function useDisplayTemplateFieldSelection(
	collection: MaybeRefOrGetter<ResolvedMonospaceCollection | undefined>,
	displayTemplate?: MaybeRefOrGetter<DisplayTemplateAst | undefined>,
): ComputedRef<FieldSelection> {
	const { fieldSelectionCtx, idCtx } = useFieldSelectionContexts();

	return computed<FieldSelection>(() => {
		const col = toValue(collection);
		if (!col) return ['*'];

		const idSelection = resolveCollectionDisplayTemplateFields(
			col,
			fieldSelectionCtx,
			toValue(displayTemplate),
		);

		return idFieldSelectionToFieldSelection(idSelection, idCtx);
	});
}
